import { CREDITS_SET } from '../types/creditsTypes.js';

const initialState = {
  value: 0,
};

export default function creditsReducer(state = initialState, action) {
  switch (action.type) {
    case CREDITS_SET:
      return { ...state, value: action.payload };
    default:
      return state;
  }
}
